import { Component, ViewChild } from '@angular/core';
import { AlertController, NavController, NavParams, PopoverController, ToastController, Content, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { PinpopoverPage } from '../pinpopover/pinpopover';
import { ChooseindoorpausePage } from '../chooseindoorpause/chooseindoorpause';

// import { LoginPage } from '../login/login';
// import { GlobalPage } from '../global/global';
// import { HomePage } from '../home/home';
import { PinemployeehomePage } from '../pinemployeehome/pinemployeehome'
/**
 * Generated class for the WorkorderspinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-workorderspin',
  templateUrl: 'workorderspin.html',
})
export class WorkorderspinPage {
  @ViewChild(Content) content: Content;
  loadingData: boolean = false
  isTabletDeks: boolean = false
  // workoders = []

  notopen = []
  open = []
  alert: any;
  _offset = 0;
  _end = false;
  _hasOpenedWithoutPauseOrder = false;
  _hasOpenedOrder = false;
  _multipleorders = '0';

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController, public popoverCtrl: PopoverController, public modalCtrl: ModalController) {
  }

  // doInfinite(infiniteScroll) {
  //   var _that = this
  //   setTimeout(() => {
  //     if (!_that._end) {
  //       _that._offset += 10;
  //       _that.loadData();
  //     }
  //     infiniteScroll.complete();
  //   }, 500);
  // }

  ionViewDidLoad() {
    var _that = this
    this.gn._Post('/api/gn/getProcessMultiple', { userid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that._multipleorders = _data + ''
    })

    console.log('ionViewDidLoad WorkorderspinPage');
    this.loadData()
    this.checkIsTablet()

    // this.content.ionScroll.subscribe((data) => {
    //   //console.log('scroll')
    // });
    // this.content.ionScrollStart.subscribe((data) => {
    //   console.log('start scroll')
    // });
    var _that = this
    this.content.ionScrollEnd.subscribe((data) => {
      clearInterval(_that.gn.timeralert);
      _that.gn.timeralert = setInterval(() => {
        _that.logoutpinandbeacon();
      }, _that.gn.resetalert * 1000);

      // if (!_that._end) {
      //   _that._offset += 10;
      //   _that.loadData();
      // }
    });
  }
  checkIsTablet() {
    // if (window.innerHeight > window.innerWidth) {
    //   this.tfm.isPhone = true
    //   console.log('isPhone')
    // } else {
    //   this.tfm.isPhone = false
    //   console.log('isDesktop')
    // }

    if (window.innerWidth > 768) {
      this.isTabletDeks = true
      console.log('isPhone')
    } else {
      this.isTabletDeks = false
      console.log('isDesktop')
    }
    // if (this.tfm.isPhone == true) {
    //   this.router.navigateByUrl('home', { skipLocationChange: true })
    // } else {
    //   this.router.navigateByUrl('tasks', { skipLocationChange: true })
    // }

  }
  // pinname

  loadData() {
    this._hasOpenedOrder = false;
    //this._hasOpenedWithoutPauseOrder = false;
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getPinLiveWorkOrders', { pinid: this.gn.crypt(this.gn.pin.pinid), type: this.gn.crypt('pin'), userid: this.gn.crypt(this.gn.user.UserId), offset: this.gn.crypt(this._offset) }, function (_data) {
      for (let i = 0; i < _data.length; i++) {
        // _data[i].dt = moment(_data[i].dt).format(this.gn.user.DFormat)
        _data[i].dt = moment(_data[i].dt).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].dt).format(_that.gn.user.TFormat)
        // if (_data[i].isopened == '0') {
        //   _that.notopen.push(_data[i])
        // } else {
        //   _that.open.push(_data[i])
        // }

        _data[i].avgdurationstr = _that.sec2str2(_data[i].avgduration)

        if (_data[i].isopened == '1' && _data[i].onpause1 == 0) _that._hasOpenedWithoutPauseOrder = true;
        if (_data[i].isopened == '1') _that._hasOpenedOrder = true;
      }
      // _that.workoders = _data
      if (_that._offset == 0)
        _that.gn.workoders = _data
      // else {
      //   if (_data.length == 0) _that._end = true;
      //   else {
      //     for (var i = 0; i < _data.length; i++)
      //       _that.gn.workoders.push(_data[i])
      //   }
      // }


      _that.resetSearch()

      _that.loadingData = false
    })

  }

  // takeOrder(_wo) {
  //   var _status = 0
  //   if (_wo.isopened == '0') {
  //     _status = 1
  //   } else {
  //     _status = 0
  //   }
  //   var _that = this
  //   _that.gn.loadWaiting();
  //   this.gn._Post('/api/gn/updateStatusPinWorkOrder', { pinid: this.gn.crypt(this.gn.pin.pinid), id: this.gn.crypt(_wo.id), status: this.gn.crypt(_status), clientid: this.gn.crypt(this.gn.user.ClientId), userid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
  //     _that.gn.loaderWaiting.dismiss();
  //     if (_data.msg == 'error') {
  //       let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
  //       toast.present();
  //       return
  //     }
  //     _that.loadData()


  //   })


  // }
  logoutpinandbeacon() {
    if (this.gn.pinemployee == true) {
      if (this.gn.alert && !this.gn.alert._detached) this.gn.alert.dismiss();
      if (this.gn.alert2 && !this.gn.alert2._detached) this.gn.alert2.dismiss();
      clearInterval(this.gn.timeralert);
      this.showPrompt(this.gn.globalPinEmployees)
    }
  }

  presentPopover(myEvent, _wo) {
    var _that = this
    // where opcii
    // 1 se misli od workorderspin
    // 2 se misli od beaconprocesshome
    _wo.ptype = 'pin'
    _wo.currentdriverid = null
    _wo.currentpinid = _that.gn.pin.pinid

    let popover = this.popoverCtrl.create(PinpopoverPage, {
      wo: _wo, where: 1, multipleorders: _that._multipleorders, cb: function (_pause) {
        if (_pause == 1 && _wo.onpause1 == 0) {
          let modal = _that.modalCtrl.create(ChooseindoorpausePage, {
            //obj: _data, seldriver: _seldriver, vid: _vid, 
            cb: function (_pausetypeid) {

              _that.gn._Post('/api/gn/updatePauseType', { ptype: _that.gn.crypt('pin'), pinid: _that.gn.crypt(_that.gn.pin.pinid), id: _that.gn.crypt(_wo.id), pausetypeid: _that.gn.crypt(_pausetypeid) }, function (_data) {
                _that._hasOpenedWithoutPauseOrder = false;
                _that._offset = 0;
                _that._end = false
                _that.loadData()

                // console.log('tuka ednas i toa e toa')
                // if (_that.gn.promptflag == false) {

                //logout samo za neaktivnost da ostane, drugovo se zakomentiruva 11-01-2022
                // setTimeout(() => {
                //   _that.logoutpinandbeacon()
                // }, 10 * 1000);
                // _that.gn.promptflag = true
                // } _that.selectedDiD = driverid
              })
            }
          });
          modal.present();
        } else {
          _that._hasOpenedWithoutPauseOrder = false;
          _that._offset = 0;
          _that._end = false
          _that.loadData()
          //alert('sto e ova')

          //logout samo za neaktivnost da ostane, drugovo se zakomentiruva 11-01-2022
          // setTimeout(() => {
          //   _that.logoutpinandbeacon()
          // }, 10 * 1000);
        }
      }
    })
    popover.present({
      ev: myEvent
    });
  }

  showPrompt(array) {

    var obj = array
    var contain = false
    var _that = this
    this.gn.alert2 = this.alertCtrl.create({
      title: _that.dic.l['login'],
      message: _that.dic.l["enteryourpin"],
      inputs: [
        {
          name: _that.dic.l['Pin'],
          placeholder: _that.dic.l['Pin']
        },
      ],
      buttons: [
        // {
        //     text: 'Cancel',
        //     handler: data => {
        //         console.log('Cancel clicked');
        //     }
        // },
        {
          text: _that.dic.l['ok'],
          handler: data => {
            for (let i = 0; i < obj.length; i++) {
              if (data.Пин + '' == obj[i].pinnumber1 + '' || data.Pin + '' == obj[i].pinnumber1 + '') {
                contain = true
                _that.gn.pin.name = obj[i].fullname
                _that.gn.pin.pinid = obj[i].id
                // _that.navCtrl.popToRoot();

                // _that._hasOpenedWithoutPauseOrder = false;
                // _that._offset = 0;
                // _that._end = false
                // _that.loadData()
                clearInterval(_that.gn.timeralert);
                _that.gn.timeralert = setInterval(() => {
                  _that.logoutpinandbeacon();
                }, _that.gn.resetalert * 1000);
                break
              }
            }
            if (contain == false) {
              _that.showPrompt(obj)
            }
            // if (contain == false) {
            //     return
            // }
            // debugger
            console.log('Saved clicked');
          }
        }
      ],
      enableBackdropDismiss: false
    });
    this.gn.alert2.present();
  }


  // openAssignDriver(_ev) {
  //   var _that = this
  //   let popover = this.popoverCtrl.create(PopupPage, {
  //     type: 'assigndriver', selected: 0, callback: function (_text, _ids) {
  //       _that.assigntime = _text
  //     }
  //   });
  //   popover.present({ ev: _ev });
  // }


  logout() {
    this.gn.clearData()
    // this.navCtrl.parent.setRoot(LoginPage)
  }
  // logoutpinandbeacon() {
  //   if (this.gn.pinemployee == true) {
  //     this.navCtrl.setRoot(GlobalPage, { key: 'pin' })
  //     if (this.gn.alert && !this.gn.alert._detached) this.gn.alert.dismiss();
  //     this.gn.showPrompt(this.gn.globalPinEmployees)
  //   }
  // }

  takeOrder(_wo) {
    if (this._hasOpenedWithoutPauseOrder && this._multipleorders == '0') {
      let toast = this.toastCtrl.create({ message: this.dic.l["cannottakeorder"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    var _status = 0
    var titletext = ''
    var subtitletext = ''
    if (_wo.isopened == '0') {
      _status = 1;
      titletext = this.dic.l['Takeorder'];
      subtitletext = this.dic.l['areusuretakeorder'];
    } else {
      _status = 0;
      titletext = this.dic.l['Closeorder'];
      subtitletext = this.dic.l['areusurecloseorder'];
    }

    var _that = this;
    let alert = _that.alertCtrl.create({
      title: titletext,
      subTitle: subtitletext + ' <b>' + _wo.title + '</b> ?',
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            _that.gn._Post('/api/gn/updateStatusPinWorkOrder', { driverid: _that.gn.crypt(_that.gn.user.driverid), pinid: _that.gn.crypt(_that.gn.pin.pinid), id: _that.gn.crypt(_wo.id), status: _that.gn.crypt(_status), clientid: _that.gn.crypt(_that.gn.user.ClientId), userid: _that.gn.crypt(_that.gn.user.UserId) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              if (_data.msg == 'error') {
                let toast = _that.toastCtrl.create({ message: _that.dic.l["someonetookit"], duration: 3000, position: 'top' });
                toast.present();
                return
              }

              //logout samo za neaktivnost da ostane, drugovo se zakomentiruva 11-01-2022
              // setTimeout(() => {
              //   _that.logoutpinandbeacon()
              // }, 10 * 1000);
              _that._hasOpenedWithoutPauseOrder = false;
              _that._offset = 0;
              _that._end = false
              _that.loadData()
            })
            //userite od mebel vi indoor da gi odlogira avtomatski posle 20sek od najavata
            //   if (_that.gn.user.ClientId + '' == '769' && _that.gn.user.driverid + '' != '-1') {
            //     setTimeout(() => {
            //       _that.logoutpinandbeacon();
            //     }, 10 * 1000);
            //   }
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  prikaz() {
    console.log('prikaz')
  }

  resetSearch() {
    for (var i = 0; i < this.gn.workoders.length; i++) {
      this.gn.workoders[i].Visible = true
    }
  }
  getItems(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchOrdersPin(val);

  }

  sec2str2(_sec) {
    if (_sec == undefined || _sec == null) _sec = -1;
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      return str;
    }
    else {
      return '-1';
    }
  }

  searchOrdersPin(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.gn.workoders.length; i++) {
        if (this.gn._latcyr(this.gn.workoders[i].title.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.gn.workoders[i].title.toLowerCase()).indexOf(val) > -1) {
          this.gn.workoders[i].Visible = true
        } else {
          if (this.gn._latcyr(this.gn.workoders[i].articlename.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.gn.workoders[i].articlename.toLowerCase()).indexOf(val) > -1) {
            this.gn.workoders[i].Visible = true
          }
          else {
            this.gn.workoders[i].Visible = false

          }
        }
      }
    }
    else {
      this.resetSearch()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/workorderspin/workorderspin.ts